
import React from 'react';
import { variables } from '../../Tenants';
import Table from '../Table';
import { useSelector, useDispatch } from 'react-redux';
import Search from '../Search';
import { onSaveInboxItem } from '../../store/actions/Inbox';
import Loader from '../Loader';

const InboxSuitesList = ({
    searchString,
    onSearch,
    onSelectItem
}) => {
    const inboxList = useSelector(state => state.inbox?.inboxList || [])  
    const suitesList = useSelector(state => state.inbox?.inboxSuitesList || []);
    const inboxLoader = useSelector(state => state.inbox?.inboxListLoader || false);
    const dispatch = useDispatch();
    const onSelectedItem = async (data) => {
      const params = {
        id: data.id,
        referenceId: data.id,
        referenceType: "Suite",
        description: data.stratalot,
        // receivedOn: moment().format('DD/MM/YYYY'),
        ticketNumber: data.number,
        message: '',
        suiteName: data.number,
        propertyName: data.propertyName,
        propertyId: data.propertyId,
        isNew: true
      };
      if(inboxList && inboxList.length > 0) {
        const inboxObj = inboxList.filter(item => item.referenceId === data.id)[0];
        if(inboxObj && inboxObj.id) {
          onSelectItem({...params, id: inboxObj.id});
        } else {
          dispatch(onSaveInboxItem(params))
          onSelectItem(params);
        }
      } else {
        dispatch(onSaveInboxItem(params))
        onSelectItem(params);
      }
    }
    return (
        <div className='announcementArea'>  
         <div id="messagesAreaBg" className='announcementPadding'> 
         {inboxLoader && <Loader center={true} />}
         <div className='searchBox'>
        <Search
          value={searchString}
          placeholder={`Search ${variables.suiteName}...`}
          onChange={onSearch}
        />
      </div>
      <div className='inboxServiceRequestTable'>
        {suitesList && suitesList.length > 0 &&
         <Table
              columns={[
                {
                  label: variables.Suite,
                  sortable: true,
                  accessor: "name",
                  cell: (data) => (
                    <div 
                    onClick={() => onSelectedItem(data)} style={{cursor:'pointer'}}
                    >
                      {data && data.number}
                    </div>
                  ),
                },
                {
                  // xsHide: true,
                  label: variables.homeOwner,
                  cell: (data) =>
                    data.homeOwners && data.homeOwners.id ? (
                      <>
                        {data.homeOwners.firstname +
                          " " +
                          data.homeOwners.lastname}
                      </>
                    ) : null,
                },
                {
                  center: true,
                  xsHide: true,
                  label: "Status",
                  accessor: "status",
                }
              ]}
              data={suitesList}
            />}
      </div>
         </div>
        </div>
    )
}

export default InboxSuitesList;